/** When your routing table is too long, you can split it into small modules**/


export default [{
  path: '/madrak-request',
  name: 'madrakRequest',
  component: () => import('@/views/madrak/Request'),
},
{
  path: '/madrak-history',
  name: 'madrakHistory',
  component: () => import('@/views/madrak/History'),
},
{
  path: '/madrak',
  name: 'madrak',
  component: () => import('@/views/madrak/Index'),
},

]

